import {
    ActivatedRouteSnapshot,
    DetachedRouteHandle,
    RouteReuseStrategy,
} from "@angular/router";

/**
 * Every authenticated URL (root, `/risks`, `/risk/{id}`, ...) renders the same
 * host component (CerrixAppComponent) via two route configs (`""` and `"**"`).
 * With Angular's default strategy those distinct configs cause the host to be
 * destroyed and rebuilt when a Back/Forward pops between them, wiping the open
 * tabs. Reusing the route whenever both sides render the same component keeps
 * the tab host alive across all in-app navigation.
 */
export class CerrixRouteReuseStrategy implements RouteReuseStrategy {
    shouldDetach(): boolean {
        return false;
    }

    store(): void {}

    shouldAttach(): boolean {
        return false;
    }

    retrieve(): DetachedRouteHandle | null {
        return null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        if (future.component && future.component === curr.component) {
            return true;
        }

        return future.routeConfig === curr.routeConfig;
    }
}
